module.exports = __webpack_public_path__ + "static/img/banner-tiu1.41b1569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-tiu1.jpg
// module id = WtZW
// module chunks = 1